<template>
  <protected :with="Permission.READ_STATISTICS" default-message>
    <div class="admin-events">
      <admin-view-header title="Zdarzenia" />

      <loader :state="actions.events" without-loading>
        <table-data
          class="is-fullwidth"
          :header="['', 'Czas', 'Zdarzenie', 'Adres IP']"
          :data="events.content"
          :data-fields="['icon', 'date', 'action', 'address']"
        >
          <template #icon="{ row }">
            <icon :name="getIcon(row.action)" :class="getColor(row.action)" />
          </template>

          <template #date="{ date, row }">
            <span :class="getColor(row.action)">{{ formatDate(date) }}</span>
          </template>

          <template #action="{ row }">
            <span :class="getColor(row.action)">{{ formatMessage(row) }}</span>
          </template>

          <template #address="{ address, row }">
            <span :class="getColor(row.action)">{{ address }}</span>
          </template>
        </table-data>

        <pagination :pageable="pageable" @change-page="requestEvents" buttons />

        <template #error>
          <div class="grey-message">
            <icon name="fa-times-circle" />
            <p>Dane niedostępne z powodu braku połączenia z serwerem.</p>
          </div>
        </template>
      </loader>
    </div>
  </protected>
</template>

<script>
import dayjs from "dayjs";

import { mapState } from "vuex";

import AdminViewHeader from "%admin/components/global/AdminViewHeader";

import { REQUEST_EVENTS } from ":actions";

import { Protected, WithDispatcherProgress } from "%mixins";

import { Icon, TableData, Pagination } from "%helpers";

import { omit } from "%utils/object";

const ACTIONS = [
  "REQUEST_EXCHANGE_TOKEN",
  "PASS_AUTHENTICATION",
  "FAIL_AUTHENTICATION",
  "RENEW_AUTH_TOKEN",
  "USE_EXPIRED_TOKEN",
  "USE_INVALID_TOKEN",
  "SEND_UNAUTHENTICATED_REQUEST",
  "SEND_UNAUTHORIZED_REQUEST"
];

const COLORS = {
  REQUEST_EXCHANGE_TOKEN: "",
  PASS_AUTHENTICATION: "",
  FAIL_AUTHENTICATION: "has-text-danger",
  RENEW_AUTH_TOKEN: "",
  USE_EXPIRED_TOKEN: "has-text-warning",
  USE_INVALID_TOKEN: "has-text-danger",
  SEND_UNAUTHENTICATED_REQUEST: "has-text-danger",
  SEND_UNAUTHORIZED_REQUEST: "has-text-warning"
};

const ICONS = {
  REQUEST_EXCHANGE_TOKEN: "fa-at",
  PASS_AUTHENTICATION: "fa-sign-in-alt",
  FAIL_AUTHENTICATION: "fa-times",
  RENEW_AUTH_TOKEN: "fa-redo",
  USE_EXPIRED_TOKEN: "fa-clock",
  USE_INVALID_TOKEN: "fa-times",
  SEND_UNAUTHENTICATED_REQUEST: "fa-times",
  SEND_UNAUTHORIZED_REQUEST: "fa-minus-circle"
};

const MESSAGES = {
  REQUEST_EXCHANGE_TOKEN: data =>
    `Próba wysłania tokenu uwierzytelniającego na adres ${data.resourceId}`,
  PASS_AUTHENTICATION: data =>
    `Użytkownik ${data.resourceId} pomyślnie zalogował się do systemu`,
  FAIL_AUTHENTICATION: () =>
    `Próba zalogowania się przy użyciu nieprawidłowego tokenu uwierzytelniającego`,
  RENEW_AUTH_TOKEN: data =>
    `Odnowiono token autoryzacyjny dla użytkownika ${data.resourceId}`,
  USE_EXPIRED_TOKEN: data =>
    `Próba uzyskania dostępu do zasobu chronionego ${data.resourceId} przy użyciu nieważnego tokenu`,
  USE_INVALID_TOKEN: data =>
    `Próba uzyskania dostępu do zasobu chronionego ${data.resourceId} przy użyciu nieprawidłowego tokenu`,
  SEND_UNAUTHENTICATED_REQUEST: data =>
    `Próba uzyskania dostępu do zasobu chronionego ${data.resourceId} bez uwierzytelnienia (brak tokenu)`,
  SEND_UNAUTHORIZED_REQUEST: data =>
    `Próba uzyskania nieautoryzowanego dostępu do chronionego zasobu ${data.resourceId} (brak uprawnień)`
};

export default {
  name: "admin-events",

  mixins: [Protected, WithDispatcherProgress],

  components: {
    AdminViewHeader,
    Icon,
    TableData,
    Pagination
  },

  computed: mapState({
    events: state => state.events.events,
    pageable: state => omit(state.events.events, "content")
  }),

  beforeMount() {
    this.requestEvents(1);
  },

  methods: {
    requestEvents(page) {
      this.dispatchWithProgress("events", REQUEST_EVENTS, {
        page,
        action: ACTIONS.join(","),
        sort: "date,desc",
        size: 10
      });
    },

    getColor(action) {
      return COLORS[action];
    },

    getIcon(action) {
      return ICONS[action];
    },

    formatDate(date) {
      return dayjs(date).format("D.MM.YYYY, HH:mm:ss");
    },

    formatMessage(data) {
      return MESSAGES[data.action](data);
    }
  }
};
</script>

<style></style>
